import Error404Page from '~components/Pages/Error404Page/Error404Page'

export default Error404Page
